export default {
  SET_CALCULATOR_COMMUNITIES (state, calculatorCommunities) {
    state.calculatorCommunities = calculatorCommunities
  },
  SET_APPLICATION_COMMUNITIES (state, applicationCommunities) {
    state.applicationCommunities = applicationCommunities
  }
}
